module.exports = __webpack_public_path__ + "img/backup-account-icon.9e17cffb.svg";